// Логика формы «Ставка / НДС / оплата» на карточке рейса.
// Вынесена из TripInput.vue, чтобы покрыть тестами (tests/unit/tripSaveLogic.test.mjs).

const pickId = (value) => (value && typeof value === 'object' ? value.id : undefined)

export function tripFormFromTrip(trip = {}) {
  return {
    id: trip.id,
    nds: trip.nds,
    tariff_type_id: pickId(trip.tariff_type),
    delivery_term_id: trip.delivery_term_id,
    payment_terms_id: trip.payment_terms_id,
    final_sum: trip.final_sum,
    executor_price: trip.executor_price,
    increased_tariff: trip.increased_tariff,
    payment_methods_id: trip.payment_methods_id,
    actual_tms_status: trip.actual_tms_status,
    comment_from_ati: trip.comment_from_ati,
  }
}

// Отправляем копию: дальнейшие правки формы не должны менять уже ушедший запрос.
export function tripSavePayload(form = {}) {
  const payload = { ...form }
  if (payload.executor_price !== null && payload.executor_price !== undefined && payload.executor_price !== '') {
    const n = Number(String(payload.executor_price).replace(/\s/g, '').replace(',', '.'))
    if (Number.isFinite(n)) payload.executor_price = n
  }
  return payload
}
